// project import
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = ({organizationName}) => (
  <SimpleBar
    sx={{
      '& .simplebar-content': {
        display: 'flex',
        flexDirection: 'column',
      }
    }}
  >
    <Navigation organizationName={organizationName} />
  </SimpleBar>
);

export default DrawerContent;
